import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/hooks/useAuth";

/**
 * Task #282 — "Show Home as Sponsor Dashboard" preference.
 *
 * When a sponsor turns this on (Sponsor Settings), the app opens to the
 * Sponsor Portal after launch and the bottom-nav Home button targets it.
 * Default OFF: everyone's home is their own recovery dashboard. Side-menu
 * links are never affected.
 *
 * Roles are hats, not walls: this gates a sponsor-only PREFERENCE lookup
 * (the endpoint itself is sponsor-only), never personal-recovery content.
 */
export function useSponsorHomeDefault(): {
  homeHref: "/" | "/sponsor-portal";
  isLoaded: boolean;
} {
  const { user, isAuthenticated } = useAuth();
  const isSponsor = user?.role === "sponsor"; // role-ok: sponsor-privilege settings endpoint

  const { data, isLoading } = useQuery<{ showHomeAsSponsorDashboard?: boolean }>({
    queryKey: ["/api/sponsor/settings"],
    enabled: !!isAuthenticated && isSponsor,
  });

  const on = isSponsor && !!data?.showHomeAsSponsorDashboard;
  return {
    homeHref: on ? "/sponsor-portal" : "/",
    isLoaded: !isSponsor || (!isLoading && data !== undefined),
  };
}
